var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandBunnerDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 7.66675L19 7.66675M14.5 1L14.5 3.22217M5.5 1L5.5 3.22217M5.5 3.22217L14.5 3.22217L15.4003 3.22217C16.6603 3.22217 17.2896 3.22217 17.7709 3.46436C18.1942 3.67749 18.5393 4.01709 18.755 4.4353C19 4.91016 19 5.53223 19 6.77441L19 7.66675L19 17.4485C19 18.6904 19 19.3115 18.755 19.7866C18.5393 20.2046 18.1942 20.5449 17.7709 20.7581C17.29 21 16.6611 21 15.4034 21L4.59656 21C3.33887 21 2.70911 21 2.22827 20.7581C1.80493 20.5449 1.46094 20.2046 1.24524 19.7866C1 19.3113 1 18.6892 1 17.4446L1 7.66675L1 6.77808C1 5.53345 1 4.91064 1.24524 4.4353C1.46094 4.01709 1.80493 3.67749 2.22827 3.46436C2.70959 3.22217 3.34009 3.22217 4.60022 3.22217L5.5 3.22217Z",
    stroke: "#FFBB4D",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandBunnerDateIcon);
export default __webpack_public_path__ + "static/media/brand-bunner-date-icon.e0c7d475feeee1af2f005ee7d75d4a69.svg";
export { ForwardRef as ReactComponent };